import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svgIcon-triangle-bottom",
  "use": "svgIcon-triangle-bottom-usage",
  "viewBox": "0 0 255 255",
  "content": "<symbol viewBox=\"0 0 255 255\" xmlns=\"http://www.w3.org/2000/svg\" id=\"svgIcon-triangle-bottom\"><path d=\"m0 63.75 127.5 127.5 127.5-127.5z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol